import Shots from "../../assets/svg/Shots";
import Pass from "../../assets/svg/Pass";
import DribPossession from "../../assets/svg/DribPossession";
import Defence from "../../assets/svg/Defence";
import Overview from "../../assets/svg/Overview";
import Goalkeeper from "../../assets/svg/Goalkeeper";

const chunkSections = (sections, chunkSize = 2) => {
  if (!Array.isArray(sections) || sections.length === 0) {
    return [];
  }

  const result = [];
  for (let index = 0; index < sections.length; index += chunkSize) {
    result.push(sections.slice(index, index + chunkSize));
  }
  return result;
};

const ICON_COMPONENTS = {
  Overview,
  Shots,
  Pass,
  "Drib-Possession": DribPossession,
  Defence,
  Goalkeeper,
};

const getTitleIcon = (title) => {
  const IconComponent = ICON_COMPONENTS[title];
  if (!IconComponent) {
    return null;
  }
  return <IconComponent />;
};

const StatsSection = ({ title, items }) => (
  <div className="bg-white border border-[#D6DBEA] rounded-xl pt-2 overflow-hidden">
    <h3 className="text-[#1A212F] font-[1000] text-lg pb-2 border-b border-[#D6DBEA] flex items-center gap-2 px-4 bg-white">
      {getTitleIcon(title)}
      {title}
    </h3>

    <div className="flex items-center justify-between px-6 py-3 bg-[#F9F9F9] border-b border-[#ECEEF6]">
      <span className="text-[#43526E] text-sm">Metric</span>
      <span className="text-[#222A35] text-sm font-bold">Value</span>
    </div>
    <div className="">
      {items.map((item, index) => {
        const showProgress = Boolean(item.displayAsProgress);
        const clampedProgress = showProgress
          ? Math.min(Math.max(Number(item.progress) || 0, 0), 1)
          : 0;
        const basePercent = Math.round(clampedProgress * 1000) / 10;
        const resolvedPercent =
          typeof item.progressPercent === "number" &&
          Number.isFinite(item.progressPercent)
            ? item.progressPercent
            : basePercent;
        const percentLabel = `${resolvedPercent.toFixed(1)}%`;
        const progressColor = showProgress ? item.progressColor : null;

        const formatCount = (value) => {
          if (value === null || value === undefined) {
            return "-";
          }
          const numeric = Number(value);
          if (!Number.isFinite(numeric)) {
            return "-";
          }
          return numeric.toLocaleString();
        };

        const hasTotal =
          item.progressTotal !== null && item.progressTotal !== undefined;
        const madeDisplay = formatCount(item.progressMade);
        const totalDisplay = hasTotal ? formatCount(item.progressTotal) : null;
        const hasValidMade = madeDisplay !== "-";
        const hasValidTotal = hasTotal && totalDisplay !== "-";
        const countsDisplay = hasValidTotal
          ? `${madeDisplay} / ${totalDisplay}`
          : hasValidMade
          ? madeDisplay
          : "-";
        const combinedLabel =
          countsDisplay !== "-"
            ? `${countsDisplay} (${percentLabel})`
            : percentLabel;

        const isLast = index === items.length - 1;

        return (
          <div
            key={item.label}
            className={`flex items-center justify-between gap-4 bg-white px-6 py-3 ${
              isLast ? "border-b-0 rounded-b-xl" : "border-b"
            } border-[#ECEEF6]`}
          >
            <span className="text-[#43526E] text-sm">
              {item.label}
            </span>
            {showProgress ? (
              <div
                className="flex items-center gap-3"
                title={item.progressAriaLabel || combinedLabel}
              >
                <span className="text-[#43526E] text-sm font-medium whitespace-nowrap min-w-[50px] text-right">
                  {percentLabel}
                </span>
                <div
                  className="h-1.5 w-24 md:w-32 bg-[#E5E6E8] rounded-full overflow-hidden"
                  role="progressbar"
                  aria-valuenow={resolvedPercent}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  aria-label={
                    item.progressAriaLabel || `${item.label} ${combinedLabel}`
                  }
                >
                  <div
                    className="h-full"
                    style={{
                      width: `${resolvedPercent}%`,
                      background: item.progressGradient || progressColor || "#2F6AF5",
                    }}
                  />
                </div>
                <span className="text-[#1A212F] font-semibold whitespace-nowrap ">
                  {countsDisplay}
                </span>
              </div>
            ) : (
              <span className="text-[#222A35] text-sm font-bold">
                {item.value ?? "-"}
              </span>
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export { chunkSections, StatsSection };
